module.exports = "<nav>\n  <div class=\"nav-wrapper\">\n    <ul class=\"left\">\n      <li (click)=\"toggleMenu()\" class=\"menu\">\n        <a>\n          <i class=\"material-icons\">{{ iconMenu }}</i>\n        </a>\n      </li>\n    </ul>\n    <a class=\"brand-logo\">\n      <i class=\"material-icons\">{{ icon }}</i>\n      {{ title }}\n    </a>\n    <ul id=\"nav-mobile\" class=\"right\">\n      <li>\n        <a (click)=\"logout()\">Sair</a>\n      </li>\n    </ul>\n  </div>\n</nav>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/navbar/navbar.component.html
// module id = ./src/app/components/navbar/navbar.component.html
// module chunks = main